import { addMonths, monthLabel, monthOf } from '@kronos/domain'
import type { LocalDate, LocalMonth } from '@kronos/domain'

/**
 * ‹ October 2026 › — real buttons, a thumb wide — and "Today" whenever the
 * calendar has been turned away from this month. The month name is announced
 * when it changes, so a screen reader hears where the buttons went.
 */
export function CalendarHeader({
  month,
  today,
  canBack,
  canForward,
  showToday,
  onGo,
  actions,
}: {
  month: LocalMonth
  today: LocalDate
  canBack: boolean
  canForward: boolean
  showToday: boolean
  onGo: (month: LocalMonth) => void
  actions?: React.ReactNode
}): JSX.Element {
  return (
    <div className="cal__head">
      <div className="cal__nav">
        <button type="button" className="cal__step" aria-label="Previous month" disabled={!canBack} onClick={() => onGo(addMonths(month, -1))}>
          ‹
        </button>
        <h3 className="cal__title" aria-live="polite">
          {monthLabel(month)}
        </h3>
        <button type="button" className="cal__step" aria-label="Next month" disabled={!canForward} onClick={() => onGo(addMonths(month, 1))}>
          ›
        </button>
      </div>
      {showToday ? (
        <button type="button" onClick={() => onGo(monthOf(today))}>
          Today
        </button>
      ) : null}
      {actions ? (
        <>
          <span className="cal__spacer" />
          {actions}
        </>
      ) : null}
    </div>
  )
}
